import { useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import appstore from "../../../assets/icon/appstore.png";
import ggplay from "../../../assets/icon/ggplay.png";
import tick from "../../../assets/icon/tick-02.svg";
import imgE3 from "../../../assets/images/imgE3.png";
import thu_ho from "../../../assets/images/thu_ho.png";
import Banner from "../../../components/Banner/Banner";
import DropdownCustom from "../../../components/ui/Dropdown";
import "./Services";
import imageBanner from "../../../assets/images/banner.png"
import { ROUTES } from "../../../constants/routers";

const Services = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="section-top">
            <div className="container">
                <Banner
                    img={imgE3}
                    bgr={imageBanner}
                >
                    <h2 className="fs-1 fw-bold">Sản phẩm - dịch vụ</h2>
                    <p className="fs-6 my-3">HPay cung cấp các giải pháp trung gian thanh toán toàn diện với nhiều dịch vụ và tiện ích cho tất cả khách hàng.</p>
                    <div className="bn-app d-flex gap-3">
                        <a href="https://play.google.com/store/apps/details?id=com.hpay.ewalletapp" target="_blank">
                            <img src={ggplay} alt={'gg'} />
                        </a>
                        <a href="https://apps.apple.com/vn/app/hpay/id6479690061" target="_blank">
                            <img src={appstore} alt={'app'} />
                        </a>
                    </div>
                </Banner>
                <div className="section-top-big">
                    <div className="row">
                        <div className="col-lg-3 d-none d-lg-block">
                            <ul className="list-unstyled">
                                <li>
                                    <Link to={ROUTES.PAYMENT_GATEWAYS} className="link-hover-tab">
                                        Cổng thanh toán
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.E_WALLETS} className="link-hover-tab">
                                        Ví điện tử
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.SERVICES} className="link-hover-tab active">
                                        Dịch vụ Thu hộ
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.FEE_SCHEDULE} className="link-hover-tab">
                                        Biểu phí
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-9 col-12">
                            <h2 className="fw-bold mt-lg-0 fs-1">Trải nghiệm tiện ích dịch vụ thu hộ</h2>
                            <div className="d-lg-none">
                                <DropdownCustom items={[
                                    { label: "Cổng thanh toán", value: ROUTES.PAYMENT_GATEWAYS },
                                    { label: "Ví điện tử", value: ROUTES.E_WALLETS },
                                    { label: "Dịch vụ Thu hộ", value: ROUTES.SERVICES },
                                    { label: "Biểu phí", value: ROUTES.FEE_SCHEDULE }
                                ]

                                }
                                    onSelect={(item) => navigate(item.value)}
                                >
                                    <div className="btn-dropdown mt-3">
                                        Dịch vụ Thu hộ
                                        <FaChevronDown className="text-secondary ms-2" />
                                    </div>
                                </DropdownCustom>
                            </div>

                            <ul className="my-4 list-unstyled">
                                <li>
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Phục vụ 24/7</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Dễ dàng tích hợp đa kênh</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Giao dịch nhanh chóng, chính xác</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Theo dõi thời gian thực</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">An toàn, bảo mật</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Tiết kiệm thời gian - chi phí - nhân lực</span>
                                </li>
                            </ul>
                            <div className="mb-4">
                                <h2 className="fw-bold mt-5 mb-1 fs-1 mb-3">Dịch vụ thu hộ</h2>
                                <p className="desc-1">
                                    HPay cung cấp tính năng thanh toán phổ biến hiện nay như: Thanh toán cho giao dịch mua hàng hóa, sản phẩm, dịch vụ, thanh toán học phí, bảo hiểm,... một cách nhanh chóng, tiện lợi và tiết kiệm.
                                </p>
                            </div>
                            <div className="my-3">
                                <img src={thu_ho} className="img-fluid" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;
